/* eslint-disable etc/no-commented-out-code */
import { logger as LOG } from '@sweetgreen/garnish';

const nativeName = 'AppsFlyer RN';
const webName = 'AppsFlyer WEB';
const nativeLibName = 'AppsFlyer RN Lib';
const mockName = 'AppsFlyer Mock';

export const nativeLogger = LOG.extend(nativeName);
export const webLogger = LOG.extend(webName);
export const nativeLibLogger = LOG.extend(nativeLibName);
export const mockLogger = LOG.extend(mockName);

// LOG.enable(nativeName);
// LOG.enable(webName);
// LOG.enable(nativeLibName);
// LOG.enable(mockName);
